import React from 'react';
import { Link } from 'react-router-dom';
import { FaShieldAlt } from 'react-icons/fa';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    legal: [
      { path: '/privacy', label: 'Privacy Policy' },
      { path: '/cookies', label: 'Cookie Policy' },
      { path: '/terms', label: 'Terms & Conditions' },
    ],
    resources: [
      { path: '/about', label: 'About Us' },
      { path: '/faq', label: 'FAQ' },
      { path: '/comparison', label: 'Compare Offers' },
    ],
  };

  return (
    <footer className="bg-dark-surface border-t border-dark-border mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img
                src="/images/logo.webp"
                alt="GameObsidian"
                className="h-10 w-auto"
                width="40"
                height="40"
                loading="lazy"
                decoding="async"
              />
              <span className="text-2xl font-bold text-gradient">GameObsidian</span>
            </Link>
            <p className="text-dark-muted mb-4">
              Your trusted source for comprehensive UK casino offer reviews. 
              We provide honest, detailed analysis to help you make informed decisions.
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-dark-muted hover:text-accent-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              {footerLinks.resources.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-dark-muted hover:text-accent-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-dark-border mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-dark-muted text-sm">
              © {currentYear} GameObsidian.com. All rights reserved.
            </p>
            
            <div className="flex items-center gap-6 flex-wrap justify-center">
              <div className="flex items-center gap-2 text-sm text-dark-muted">
                <FaShieldAlt />
                <span>18+ Only</span>
              </div>
              <a
                href="https://www.begambleaware.org"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-dark-muted hover:text-accent-primary transition-colors"
              >
                BeGambleAware
              </a>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-4 mt-6">
            <img
              src="/images/footer/begambleaware.webp"
              alt="BeGambleAware"
              className="h-8 opacity-70 hover:opacity-100 transition-opacity"
              width="120"
              height="32"
              loading="lazy"
              decoding="async"
            />
            <img
              src="/images/footer/gambling-commission.webp"
              alt="Gambling Commission"
              className="h-8 opacity-70 hover:opacity-100 transition-opacity"
              width="120"
              height="32"
              loading="lazy"
              decoding="async"
            />
            <img
              src="/images/footer/gamcare.webp"
              alt="GamCare"
              className="h-8 opacity-70 hover:opacity-100 transition-opacity"
              width="120"
              height="32"
              loading="lazy"
              decoding="async"
            />
            <img
              src="/images/footer/gambling-therapy-logo.webp"
              alt="Gambling Therapy"
              className="h-8 opacity-70 hover:opacity-100 transition-opacity"
              width="120"
              height="32"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

